/* typewriter.ro — interactive 3D keyboard.
   Config (optional) as JSON in data-kb on #twKb3d:
   { layout: '75'|'65'|'tkl'|'full', lp: bool (low profile), knob: bool,
     case: '#hex', plate: '#hex', stem: '#hex',
     caps: { a: alpha, m: modifiers, x: accent, la, lm, lx: legend colours },
     label: { brand, line }, ui: 'ro'|'en' }
   Live updates: window.__twkb.set({ stem, case, caps }) */
(function () {
  var host = document.getElementById('twKb3d');
  if (!host || !window.THREE) return;
  var T = THREE;
  var cfg = {};
  try { cfg = JSON.parse(host.getAttribute('data-kb') || '{}') || {}; } catch (e) { cfg = {}; }
  var LAYOUT = cfg.layout || '75', LP = !!cfg.lp;
  var CAPS = Object.assign({ a: '#f1ece2', m: '#8d8a84', x: '#b8322a', la: '#2a2925', lm: '#ffffff', lx: '#ffffff' }, cfg.caps || {});
  var UI_RO = cfg.ui === 'ro';

  // ---------- layouts: [legend, width, class, height]; class '' alpha, m modifier, a accent, n knob, g gap ----------
  function keys(s, c) { return s.split(' ').map(function (t) { return [t, 1, c || '']; }); }
  function chars(s) { return s.split('').map(function (t) { return [t, 1, '']; }); }
  function fn(a, b) { var o = []; for (var i = a; i <= b; i++) o.push(['F' + i, 1, '']); return o; }
  var G = function (w) { return ['', w, 'g']; };
  var R = {};
  R['75'] = [
    [['Esc', 1, 'a']].concat(fn(1, 12)).concat([['Del', 1, ''], ['', 1, cfg.knob === false ? 'm' : 'n']]),
    [['`', 1, '']].concat(chars('1234567890-=')).concat([['⌫', 2, 'm'], ['Home', 1, 'm']]),
    [['Tab', 1.5, 'm']].concat(chars('QWERTYUIOP[]')).concat([['\\', 1.5, 'm'], ['PgUp', 1, 'm']]),
    [['Caps', 1.75, 'm']].concat(chars("ASDFGHJKL;'")).concat([['Enter', 2.25, 'a'], ['PgDn', 1, 'm']]),
    [['Shift', 2.25, 'm']].concat(chars('ZXCVBNM,./')).concat([['Shift', 1.75, 'm'], ['↑', 1, 'm'], ['End', 1, 'm']]),
    [['Ctrl', 1.25, 'm'], ['Win', 1.25, 'm'], ['Alt', 1.25, 'm'], ['', 6.25, ''], ['Alt', 1, 'm'], ['Fn', 1, 'm'], ['Ctrl', 1, 'm'], ['←', 1, 'm'], ['↓', 1, 'm'], ['→', 1, 'm']]
  ];
  R['65'] = [
    [['Esc', 1, 'a']].concat(chars('1234567890-=')).concat([['⌫', 2, 'm'], ['Del', 1, 'm']]),
    [['Tab', 1.5, 'm']].concat(chars('QWERTYUIOP[]')).concat([['\\', 1.5, 'm'], ['PgUp', 1, 'm']]),
    [['Caps', 1.75, 'm']].concat(chars("ASDFGHJKL;'")).concat([['Enter', 2.25, 'a'], ['PgDn', 1, 'm']]),
    [['Shift', 2.25, 'm']].concat(chars('ZXCVBNM,./')).concat([['Shift', 1.75, 'm'], ['↑', 1, 'm'], ['End', 1, 'm']]),
    [['Ctrl', 1.25, 'm'], ['Win', 1.25, 'm'], ['Alt', 1.25, 'm'], ['', 6.25, ''], ['Alt', 1, 'm'], ['Fn', 1, 'm'], ['Ctrl', 1, 'm'], ['←', 1, 'm'], ['↓', 1, 'm'], ['→', 1, 'm']]
  ];
  R.tkl = [
    [['Esc', 1, 'a'], G(1)].concat(fn(1, 4), [G(0.5)], fn(5, 8), [G(0.5)], fn(9, 12), [G(0.25)], keys('PrtSc ScrLk Pause', 'm')),
    [['`', 1, '']].concat(chars('1234567890-=')).concat([['⌫', 2, 'm'], G(0.25)], keys('Ins Home PgUp', 'm')),
    [['Tab', 1.5, 'm']].concat(chars('QWERTYUIOP[]')).concat([['\\', 1.5, 'm'], G(0.25)], keys('Del End PgDn', 'm')),
    [['Caps', 1.75, 'm']].concat(chars("ASDFGHJKL;'")).concat([['Enter', 2.25, 'a']]),
    [['Shift', 2.25, 'm']].concat(chars('ZXCVBNM,./')).concat([['Shift', 2.75, 'm'], G(1.25), ['↑', 1, 'm']]),
    [['Ctrl', 1.25, 'm'], ['Win', 1.25, 'm'], ['Alt', 1.25, 'm'], ['', 6.25, ''], ['Alt', 1.25, 'm'], ['Fn', 1.25, 'm'], ['Menu', 1.25, 'm'], ['Ctrl', 1.25, 'm'], G(0.25)].concat(keys('← ↓ →', 'm'))
  ];
  R.full = R.tkl.map(function (r) { return r.slice(); });
  R.full[1] = R.full[1].concat([G(0.25)], keys('Num / * -', 'm'));
  R.full[2] = R.full[2].concat([G(0.25)], chars('789'), [['+', 1, 'm', 2]]);
  R.full[3] = R.full[3].concat([G(3.25 + 0.25)], chars('456'));
  R.full[4] = R.full[4].concat([G(1.25)], chars('123'), [['Ent', 1, 'a', 2]]);
  R.full[5] = R.full[5].concat([G(0.25), ['0', 2, ''], ['.', 1, '']]);
  var ROWS = R[LAYOUT] || R['75'];
  var hasF = LAYOUT !== '65';

  // ---------- dimensions ----------
  var KEYS = [], z = 0, W = 0;
  ROWS.forEach(function (row, ri) {
    var x = 0;
    row.forEach(function (k) {
      var h = k[3] || 1;
      if (k[2] !== 'g') KEYS.push({ t: k[0], w: k[1], h: h, c: k[2], x0: x, z0: z });
      x += k[1];
    });
    W = Math.max(W, x);
    z += 1 + (ri === 0 && hasF ? 0.25 : 0);
  });
  var D = z;
  KEYS.forEach(function (k) { k.cx = k.x0 + k.w / 2 - W / 2; k.cz = k.z0 + k.h / 2 - D / 2; });
  var M = 0.45, CASE_H = LP ? 0.72 : 1.1, PLATE = CASE_H - (LP ? 0.1 : 0.15), CAP_H = LP ? 0.3 : 0.62, TOP = LP ? 0.9 : 0.76;
  var SW_H = LP ? 0.22 : 0.42, STEM_Y = LP ? 0.2 : 0.45; // stem top stays under the keycap top
  var cw = W + M * 2, cd = D + M * 2;
  var S = W / 16; // scale relative to the original 75 %
  var FIT = Math.max(Math.pow(S, 0.6), 0.9); // camera distance factor: bigger boards fill the frame too

  var renderer = new T.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: !!cfg.capture });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.toneMapping = T.ACESFilmicToneMapping;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = T.PCFSoftShadowMap;
  host.appendChild(renderer.domElement);

  var scene = new T.Scene();
  var camera = new T.PerspectiveCamera(28, 4 / 3, 0.1, 300);

  scene.add(new T.HemisphereLight(0xfffaf0, 0x8a8478, 0.8));
  var sun = new T.DirectionalLight(0xffffff, 1.2);
  sun.position.set(-8 * S, 18, 10);
  sun.castShadow = true;
  sun.shadow.mapSize.set(2048, 2048);
  var sc = sun.shadow.camera, ext = 14 * Math.max(1, S); sc.left = -ext; sc.right = ext; sc.top = ext; sc.bottom = -ext; sc.near = 1; sc.far = 80;
  sun.shadow.radius = 7;
  scene.add(sun);
  var fill = new T.DirectionalLight(0xfff1e0, 0.45); fill.position.set(10, -4, 8); scene.add(fill);

  var ground = new T.Mesh(new T.PlaneGeometry(140, 140), new T.ShadowMaterial({ opacity: 0.14 }));
  ground.rotation.x = -Math.PI / 2; ground.position.y = -5.5 * Math.max(1, S); ground.receiveShadow = true;
  scene.add(ground);

  function col(hex) { return new T.Color(hex).convertSRGBToLinear(); }
  function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function texOf(c) { var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.anisotropy = renderer.capabilities.getMaxAnisotropy(); return t; }

  var pivot = new T.Group(); scene.add(pivot);
  var kb = new T.Group(); kb.position.y = -CASE_H / 2; pivot.add(kb);

  // ---------- case ----------
  var r = 0.55, sh = new T.Shape();
  sh.moveTo(-cw / 2 + r, -cd / 2); sh.lineTo(cw / 2 - r, -cd / 2); sh.quadraticCurveTo(cw / 2, -cd / 2, cw / 2, -cd / 2 + r);
  sh.lineTo(cw / 2, cd / 2 - r); sh.quadraticCurveTo(cw / 2, cd / 2, cw / 2 - r, cd / 2);
  sh.lineTo(-cw / 2 + r, cd / 2); sh.quadraticCurveTo(-cw / 2, cd / 2, -cw / 2, cd / 2 - r);
  sh.lineTo(-cw / 2, -cd / 2 + r); sh.quadraticCurveTo(-cw / 2, -cd / 2, -cw / 2 + r, -cd / 2);
  var cg = new T.ExtrudeGeometry(sh, { depth: CASE_H - 0.16, bevelEnabled: true, bevelSize: 0.08, bevelThickness: 0.08, bevelSegments: 3, curveSegments: 10 });
  cg.rotateX(-Math.PI / 2); cg.translate(0, 0.08, 0);
  var caseMat = new T.MeshStandardMaterial({ color: col(cfg.case || '#2e2d32'), metalness: cfg.caseMetal == null ? 0.55 : cfg.caseMetal, roughness: 0.38 });
  var caseMesh = new T.Mesh(cg, caseMat); caseMesh.castShadow = true; caseMesh.receiveShadow = true; kb.add(caseMesh);

  // ---------- plate with cut-outs ----------
  var PPX = 64, pc = canvas(Math.round(W * PPX), Math.round(D * PPX)), px = pc.getContext('2d');
  px.fillStyle = cfg.plate || '#a4a6aa'; px.fillRect(0, 0, pc.width, pc.height);
  px.fillStyle = '#18181b';
  KEYS.forEach(function (k) {
    var X = (k.cx + W / 2) * PPX, Z = (k.cz + D / 2) * PPX;
    if (k.c === 'n') { px.beginPath(); px.arc(X, Z, 0.42 * PPX, 0, 7); px.fill(); return; }
    px.fillRect(X - 0.29 * PPX, Z - 0.29 * PPX, 0.58 * PPX, 0.58 * PPX);
    if (k.w >= 2) { px.fillRect(X - k.w * 0.38 * PPX, Z - 0.12 * PPX, 0.14 * PPX, 0.3 * PPX); px.fillRect(X + k.w * 0.38 * PPX - 0.14 * PPX, Z - 0.12 * PPX, 0.14 * PPX, 0.3 * PPX); }
  });
  var plateTop = new T.MeshStandardMaterial({ map: texOf(pc), metalness: 0.6, roughness: 0.42 });
  var plateSide = new T.MeshStandardMaterial({ color: col(0x8f9195), metalness: 0.6, roughness: 0.45 });
  var plate = new T.Mesh(new T.BoxGeometry(W + 0.12, 0.06, D + 0.12), [plateSide, plateSide, plateTop, plateSide, plateSide, plateSide]);
  plate.position.y = PLATE; plate.receiveShadow = true; kb.add(plate);

  // ---------- switches (instanced) ----------
  var swKeys = KEYS.filter(function (k) { return k.c !== 'n'; });
  var m4 = new T.Matrix4();
  var housing = new T.InstancedMesh(new T.BoxGeometry(0.56, SW_H, 0.56), new T.MeshStandardMaterial({ color: col(0x2a2a30), roughness: 0.35, metalness: 0.1, transparent: true, opacity: 0.92 }), swKeys.length);
  var stemMat = new T.MeshStandardMaterial({ color: col(cfg.stem || '#d0202a'), roughness: 0.45 });
  var stemA = new T.InstancedMesh(new T.BoxGeometry(0.17, LP ? 0.16 : 0.3, 0.05), stemMat, swKeys.length);
  var stemB = new T.InstancedMesh(new T.BoxGeometry(0.05, LP ? 0.16 : 0.3, 0.17), stemMat, swKeys.length);
  var leds = new T.InstancedMesh(new T.BoxGeometry(0.2, 0.04, 0.1), new T.MeshBasicMaterial({ color: 0xffffff, toneMapped: false }), swKeys.length);
  swKeys.forEach(function (k, i) {
    m4.makeTranslation(k.cx, PLATE + SW_H / 2 + 0.03, k.cz); housing.setMatrixAt(i, m4);
    m4.makeTranslation(k.cx, PLATE + STEM_Y, k.cz); stemA.setMatrixAt(i, m4); stemB.setMatrixAt(i, m4);
    m4.makeTranslation(k.cx, PLATE + 0.05, k.cz + 0.36); leds.setMatrixAt(i, m4);
    leds.setColorAt(i, new T.Color(0xffffff));
  });
  housing.castShadow = true;
  kb.add(housing, stemA, stemB, leds);

  // ---------- keycaps + legends (lift together) ----------
  var caps = new T.Group(); kb.add(caps);
  var mats = {
    '': new T.MeshStandardMaterial({ color: col(CAPS.a), roughness: 0.62 }),
    m: new T.MeshStandardMaterial({ color: col(CAPS.m), roughness: 0.6 }),
    a: new T.MeshStandardMaterial({ color: col(CAPS.x), roughness: 0.55 })
  };
  var capCache = {};
  function capGeo(w, h) {
    var id = w + 'x' + h;
    if (capCache[id]) return capCache[id];
    var g = new T.CylinderGeometry(Math.SQRT1_2 * TOP, Math.SQRT1_2, CAP_H, 4, 1);
    g.rotateY(Math.PI / 4);
    var p = g.attributes.position;
    for (var i = 0; i < p.count; i++) {
      var x = p.getX(i), y = p.getY(i), zz = p.getZ(i), half = y > 0 ? TOP / 2 : 0.5;
      if (Math.abs(x) > 1e-6) p.setX(i, (x > 0 ? 1 : -1) * (half + (w * 0.96 - 0.96) / 2) * 0.96);
      if (Math.abs(zz) > 1e-6) p.setZ(i, (zz > 0 ? 1 : -1) * (half + (h * 0.96 - 0.96) / 2) * 0.96);
    }
    g.computeVertexNormals();
    return (capCache[id] = g);
  }
  var LPX = 128, lc = canvas(Math.round(W * LPX), Math.round(D * LPX)), lx = lc.getContext('2d');
  function drawLegends() {
    lx.clearRect(0, 0, lc.width, lc.height);
    lx.textBaseline = 'top';
    KEYS.forEach(function (k) {
      if (!k.t || k.c === 'n') return;
      lx.fillStyle = k.c === 'a' ? CAPS.lx : k.c === 'm' ? CAPS.lm : CAPS.la;
      lx.font = '600 ' + (k.t.length > 2 ? 22 : 30) + 'px "IBM Plex Mono", monospace';
      lx.fillText(k.t, (k.cx + W / 2 - (k.w * 0.96 - 0.96 + TOP) * 0.48 + 0.07) * LPX, (k.cz + D / 2 - (k.h * 0.96 - 0.96 + TOP) * 0.48 + 0.06) * LPX);
    });
  }
  KEYS.forEach(function (k) {
    if (k.c === 'n') {
      var knob = new T.Mesh(new T.CylinderGeometry(0.36, 0.38, 0.6, 40), new T.MeshStandardMaterial({ color: col(0x55545a), metalness: 0.85, roughness: 0.3 }));
      knob.position.set(k.cx, PLATE + 0.3, k.cz); knob.castShadow = true; kb.add(knob);
      return;
    }
    var cap = new T.Mesh(capGeo(k.w, k.h), mats[k.c]);
    cap.position.set(k.cx, PLATE + CAP_H / 2 + 0.06, k.cz);
    cap.castShadow = true; cap.receiveShadow = true; caps.add(cap);
  });
  drawLegends();
  var legendTex = texOf(lc);
  var legends = new T.Mesh(new T.PlaneGeometry(W, D), new T.MeshBasicMaterial({ map: legendTex, transparent: true, depthWrite: false }));
  legends.rotation.x = -Math.PI / 2; legends.position.y = PLATE + CAP_H + 0.065; caps.add(legends);

  // ---------- underside ----------
  var BPX = 96, bc = canvas(Math.round(cw * BPX), Math.round(cd * BPX)), bx = bc.getContext('2d');
  var LEG_X = W * 0.34;
  function drawBottom() {
    bx.fillStyle = cfg.bottom || '#34333a'; bx.fillRect(0, 0, bc.width, bc.height);
    for (var i = 0; i < 900; i++) { bx.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.035) + ')'; bx.fillRect(0, Math.random() * bc.height, bc.width, 1); }
    [[0.7, 0.6], [cw / 2, 0.6], [cw - 0.7, 0.6], [0.7, cd - 0.6], [cw / 2, cd - 0.6], [cw - 0.7, cd - 0.6]].forEach(function (s) {
      bx.fillStyle = '#1d1c21'; bx.beginPath(); bx.arc(s[0] * BPX, s[1] * BPX, 0.13 * BPX, 0, 7); bx.fill();
      bx.strokeStyle = '#55545c'; bx.lineWidth = 3; bx.beginPath(); bx.moveTo((s[0] - 0.07) * BPX, s[1] * BPX); bx.lineTo((s[0] + 0.07) * BPX, s[1] * BPX); bx.moveTo(s[0] * BPX, (s[1] - 0.07) * BPX); bx.lineTo(s[0] * BPX, (s[1] + 0.07) * BPX); bx.stroke();
    });
    function recess(x) { bx.fillStyle = '#1f1e23'; bx.fillRect((x - 0.85) * BPX, (cd - 1.75) * BPX, 1.7 * BPX, 1.5 * BPX); }
    recess(cw / 2 - LEG_X); recess(cw / 2 + LEG_X);
    var lab = cfg.label || {};
    var LW = 6.4 * BPX, LH = 2.1 * BPX, L0 = (cw / 2) * BPX - LW / 2, T0 = (cd / 2 - (D < 5.5 ? 0.9 : 0.65)) * BPX;
    bx.fillStyle = '#e9e5dc'; bx.fillRect(L0, T0, LW, LH);
    bx.fillStyle = '#1c1b19'; bx.textBaseline = 'top';
    bx.font = '700 34px Inter, sans-serif'; bx.fillText(lab.brand || 'YOUR BRAND', L0 + 22, T0 + 18);
    bx.font = '500 20px "IBM Plex Mono", monospace';
    bx.fillText(lab.line || 'Model 75 · Wireless mechanical keyboard', L0 + 22, T0 + 62);
    bx.fillText(lab.power || '5V ⎓ 500mA · Li-ion 4000 mAh', L0 + 22, T0 + 90);
    bx.fillText('EU: imported by Typewriter · typewriter.ro', L0 + 22, T0 + 118);
    bx.font = '700 40px Inter, sans-serif'; bx.fillText('CE', L0 + 22, T0 + 150);
    var bxl = L0 + 100, btp = T0 + 148;
    bx.strokeStyle = '#1c1b19'; bx.lineWidth = 3;
    bx.strokeRect(bxl + 6, btp + 8, 26, 32); bx.beginPath(); bx.moveTo(bxl + 2, btp + 8); bx.lineTo(bxl + 36, btp + 8);
    bx.moveTo(bxl, btp + 2); bx.lineTo(bxl + 38, btp + 46); bx.moveTo(bxl + 38, btp + 2); bx.lineTo(bxl, btp + 46); bx.stroke();
  }
  drawBottom();
  var bottomTex = texOf(bc);
  var bottom = new T.Mesh(new T.PlaneGeometry(cw - 0.2, cd - 0.2), new T.MeshStandardMaterial({ map: bottomTex, metalness: 0.45, roughness: 0.5 }));
  bottom.rotation.x = Math.PI / 2; bottom.position.y = -0.004; kb.add(bottom);

  // rubber feet
  var rubber = new T.MeshStandardMaterial({ color: col(0x141416), roughness: 0.95 });
  [[-1, 1], [1, 1]].forEach(function (s) {
    var f = new T.Mesh(new T.CylinderGeometry(0.36, 0.36, 0.1, 32), rubber);
    f.position.set(s[0] * (cw / 2 - 1.1), -0.05, s[1] * (cd / 2 - 0.65)); kb.add(f);
  });
  [[-1], [1]].forEach(function (s) {
    var stripF = new T.Mesh(new T.BoxGeometry(2.4, 0.1, 0.36), rubber);
    stripF.position.set(s[0] * (cw / 2 - 1.9), -0.05, -cd / 2 + 2.2); kb.add(stripF);
  });

  // flip-out legs
  var legMat = new T.MeshStandardMaterial({ color: col(0x1b1b1f), roughness: 0.55, metalness: 0.2 });
  var legs = [];
  [-LEG_X, LEG_X].forEach(function (x) {
    var hinge = new T.Group(); hinge.position.set(x, -0.02, -cd / 2 + 0.3); kb.add(hinge);
    var outer = new T.Mesh(new T.BoxGeometry(1.6, 0.1, 1.35), legMat); outer.position.set(0, -0.05, 0.68); outer.castShadow = true; hinge.add(outer);
    var tip = new T.Mesh(new T.BoxGeometry(1.6, 0.12, 0.18), rubber); tip.position.set(0, -0.06, 1.3); hinge.add(tip);
    var pin = new T.Mesh(new T.CylinderGeometry(0.07, 0.07, 1.7, 12), new T.MeshStandardMaterial({ color: col(0x9a9ca0), metalness: 0.9, roughness: 0.3 }));
    pin.rotation.z = Math.PI / 2; pin.position.y = -0.05; hinge.add(pin);
    legs.push({ a: hinge });
  });

  // RGB light strip around the bottom edge
  var SEG = [], per = 2 * (cw + cd), segL = 0.36, nSeg = Math.floor(per / segL);
  var strip = new T.InstancedMesh(new T.BoxGeometry(segL * 0.9, 0.07, 0.07), new T.MeshBasicMaterial({ color: 0xffffff, toneMapped: false }), nSeg);
  var q0 = new T.Quaternion(), v0 = new T.Vector3(), s1 = new T.Vector3(1, 1, 1), yAx = new T.Vector3(0, 1, 0);
  for (var si = 0; si < nSeg; si++) {
    var d = si * segL, x, zz, ang = 0, o = 0.1;
    if (d < cw) { x = -cw / 2 + d; zz = cd / 2 + o; }
    else if (d < cw + cd) { x = cw / 2 + o; zz = cd / 2 - (d - cw); ang = Math.PI / 2; }
    else if (d < 2 * cw + cd) { x = cw / 2 - (d - cw - cd); zz = -cd / 2 - o; }
    else { x = -cw / 2 - o; zz = -cd / 2 + (d - 2 * cw - cd); ang = Math.PI / 2; }
    q0.setFromAxisAngle(yAx, ang);
    m4.compose(v0.set(x, 0.06, zz), q0, s1); strip.setMatrixAt(si, m4);
    strip.setColorAt(si, new T.Color(0xffffff));
    SEG.push(d / per);
  }
  kb.add(strip);

  // ---------- state & controls ----------
  var state = { feet: 0, feetT: 0, inside: 0, insideT: 0, lights: 1, lightsT: cfg.rgb === false ? 0 : 1 };
  var q = new T.Quaternion().setFromAxisAngle(yAx, -0.35);
  var flip = null, xAx = new T.Vector3(1, 0, 0);
  var st = document.createElement('style');
  st.textContent = '#twKb3d{touch-action:none}.kb-ui{position:absolute;left:10px;right:10px;bottom:10px;display:flex;flex-wrap:wrap;gap:6px;z-index:2}' +
    '.kb-ui button{font:500 11px "IBM Plex Mono",monospace;color:#1c1b19;background:rgba(255,255,255,.88);border:1px solid #cfc7b6;border-radius:999px;padding:6px 11px;cursor:pointer}' +
    '.kb-ui button.on{background:#1c1b19;color:#f3efe6;border-color:#1c1b19}';
  document.head.appendChild(st);
  var ui = document.createElement('div'); ui.className = 'kb-ui';
  var EN = !UI_RO || document.documentElement.lang === 'en';
  function lb(ro, en) { return UI_RO ? ' data-en="' + en + '" data-ro="' + ro + '">' + (EN ? en : ro) : '>' + en; }
  ui.innerHTML = '<button type="button" data-a="flip"' + lb('↻ Întoarce', '↻ Flip over') + '</button>' +
    '<button type="button" data-a="feet"' + lb('Picioare', 'Feet') + '</button>' +
    '<button type="button" data-a="inside"' + lb('Plate și switch-uri', 'Plate &amp; switches') + '</button>' +
    '<button type="button" data-a="lights"' + lb('RGB', 'RGB') + '</button>';
  host.parentNode.appendChild(ui);
  var hint = host.parentNode.querySelector('.hint');
  if (hint && !UI_RO) hint.textContent = 'Drag to rotate · any angle';
  function syncUi() {
    ui.querySelectorAll('button').forEach(function (b) {
      var a = b.getAttribute('data-a');
      b.classList.toggle('on', !!((a === 'feet' && state.feetT) || (a === 'inside' && state.insideT) || (a === 'lights' && state.lightsT) || (a === 'flip' && isFlipped())));
    });
  }
  function isFlipped() { return new T.Vector3(0, 1, 0).applyQuaternion(q).y < 0; }
  function doFlip() {
    var end = new T.Quaternion().setFromAxisAngle(xAx, Math.PI).multiply(q);
    flip = { from: q.clone(), to: end, t: 0 };
  }
  ui.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return;
    var a = b.getAttribute('data-a');
    if (a === 'flip') doFlip();
    if (a === 'feet') { state.feetT = state.feetT ? 0 : 1; if (state.feetT && !isFlipped()) doFlip(); }
    if (a === 'inside') { state.insideT = state.insideT ? 0 : 1; if (state.insideT && isFlipped()) doFlip(); }
    if (a === 'lights') state.lightsT = state.lightsT ? 0 : 1;
    idle = 0; setTimeout(syncUi, 950); syncUi();
  });

  // drag (mouse or finger) rotates freely in every direction
  var velX = 0, velY = 0, dragging = false, lastX = 0, lastY = 0, idle = 0;
  host.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; lastY = e.clientY; flip = null; try { host.setPointerCapture(e.pointerId); } catch (_) {} });
  host.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var dx = e.clientX - lastX, dy = e.clientY - lastY; lastX = e.clientX; lastY = e.clientY;
    velY = dx * 0.009; velX = dy * 0.009;
    spin(velY, velX); idle = 0;
  });
  function up() { if (dragging) { dragging = false; syncUi(); } }
  host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up);
  var qa = new T.Quaternion();
  function spin(ry, rx) {
    if (ry) q.premultiply(qa.setFromAxisAngle(yAx, ry));
    if (rx) q.premultiply(qa.setFromAxisAngle(xAx, rx));
    q.normalize();
  }

  function size() {
    var w = host.clientWidth, h = host.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    var dist = (w / h < 1.1 ? 40 : 33) * FIT * (cfg.zoom || 1);
    camera.position.set(0, dist * 0.55, dist * 0.84);
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
  }
  size();
  window.addEventListener('resize', size);
  if (window.ResizeObserver) new ResizeObserver(size).observe(host);

  var visible = true;
  if (window.IntersectionObserver) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(host);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function approach(cur, tgt, dt, speed) { var dd = tgt - cur, s = dt * speed; return Math.abs(dd) <= s ? tgt : cur + Math.sign(dd) * s; }

  var tmpC = new T.Color(), last = performance.now(), time = 0, paused = false;
  function frame(dt) {
    if (flip) {
      flip.t = Math.min(1, flip.t + dt / 0.9);
      T.Quaternion.slerp(flip.from, flip.to, q, ease(flip.t));
      if (flip.t >= 1) { flip = null; syncUi(); }
    } else if (!dragging && !paused) {
      idle += dt;
      velY *= 0.93; velX *= 0.93; spin(velY, velX);
      if (idle > 2 && !reduce) spin(dt * 0.25, 0);
    }
    pivot.quaternion.copy(q);
    state.feet = approach(state.feet, state.feetT ? 1 : 0, dt, 1.2);
    legs.forEach(function (l) { l.a.rotation.x = 1.15 * ease(state.feet); });
    state.inside = approach(state.inside, state.insideT ? 1 : 0, dt, 1.4);
    caps.position.y = (LP ? 1.8 : 2.6) * ease(state.inside);
    state.lights = approach(state.lights, state.lightsT ? 1 : 0, dt, 2);
    var L = state.lights;
    for (var i = 0; i < swKeys.length; i++) {
      tmpC.setHSL(((swKeys[i].cx / W) * 0.6 + time * 0.08) % 1, 0.9, 0.55 * L + 0.04);
      leds.setColorAt(i, tmpC);
    }
    leds.instanceColor.needsUpdate = true;
    for (var j = 0; j < nSeg; j++) {
      tmpC.setHSL((SEG[j] + time * 0.08) % 1, 0.9, 0.55 * L + 0.03);
      strip.setColorAt(j, tmpC);
    }
    strip.instanceColor.needsUpdate = true;
    renderer.render(scene, camera);
  }
  function tick(now) {
    requestAnimationFrame(tick);
    var dt = Math.min(0.05, (now - last) / 1000); last = now; time += dt;
    if (!visible || !host.clientWidth) return;
    frame(dt);
  }
  syncUi();
  requestAnimationFrame(tick);

  // ---------- public API ----------
  function set(o) {
    o = o || {};
    if (o.stem) stemMat.color.copy(col(o.stem));
    if (o.case) caseMat.color.copy(col(o.case));
    if (o.caps) {
      Object.assign(CAPS, o.caps);
      mats[''].color.copy(col(CAPS.a)); mats.m.color.copy(col(CAPS.m)); mats.a.color.copy(col(CAPS.x));
      drawLegends(); legendTex.needsUpdate = true;
    }
  }
  // pose for still renders: yaw/pitch in radians, optional state
  function pose(o) {
    o = o || {};
    paused = true; flip = null;
    q.setFromEuler(new T.Euler(o.pitch || 0, o.yaw || 0, 0, 'YXZ'));
    if (o.inside != null) { state.insideT = state.inside = o.inside; }
    if (o.lights != null) { state.lightsT = state.lights = o.lights; }
    frame(0);
    return renderer.domElement;
  }
  // still image for product photos: { w, h, yaw, pitch, inside, lights, bg, zoom, cy } -> PNG data URL
  function snap(o) {
    o = o || {};
    var w = o.w || 1600, h = o.h || 1200, pr = renderer.getPixelRatio();
    renderer.setPixelRatio(1); renderer.setSize(w, h, false);
    renderer.setClearColor(new T.Color(o.bg || '#efe9de'), 1);
    camera.aspect = w / h;
    var dist = 33 * FIT * (o.zoom || 1);
    camera.position.set(0, dist * (o.cy || 0.55), dist * 0.84); camera.lookAt(0, 0, 0); camera.updateProjectionMatrix();
    var c = pose(o), url = c.toDataURL('image/png');
    renderer.setClearColor(0x000000, 0); renderer.setPixelRatio(pr); size(); frame(0); paused = false;
    return url;
  }
  window.__twkb = { pivot: pivot, kb: kb, camera: camera, state: state, flip: doFlip, set: set, pose: pose, snap: snap, resume: function () { paused = false; }, canvas: renderer.domElement };
  host.dispatchEvent(new CustomEvent('tw:kb-ready', { bubbles: true }));
})();
